import React from 'react';
import { Link, NavLink, useNavigate } from "react-router-dom";
import './Footer.css';
import Index from '../../Assets/Images/Index';


export default function Footer() {
  const footerLinks = [
    { name: "Sell", link: "/sell", },
    // { name: "Market", link: "/market", },
    { name: "Manage", link: "/manage", },
    // { name: "Learn", link: "/learn", },
    { name: "Pricing", link: "/pricing", },
    { name: "Contact", link: "/contact", },
    { name: "FAQ", link: "/faq", },
    { name: "Documentation", link: "/doc", }
  ]
  return (
    <footer id="footer" className="footer">
      <div className="container">
        <div className="footerInner">
          <div className="logo"><NavLink to="/">
            <img src={Index.logoWhite} alt="" width="173" />
          </NavLink></div>
          <nav id="navbar">
            <ul>
              {footerLinks.map((item, index) => {
                return (
                  <li key={index}>
                    <NavLink to={item.link}>{item.name}</NavLink>
                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
        <div className="copyright">
          <small><span>&#169;</span> Copyright {new Date().getFullYear()}. All Rights Reserved</small>
          <div className="footerContact">
            <small>Shopyxa is a product from <a href="https://www.webexpertsonline.net/" target="_blank" rel="noreferrer">Web Experts Online</a></small>
          </div>
          <div className="footerLinks">
            <ul>
              <li><Link to="/terms-of-use">Terms of use</Link> </li>
              <li><Link to="/privacy-policy">Privacy Policy </Link> </li>
              <li><Link to="/refund-policy">Refund Policy </Link> </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}
